(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupStatusDeleteController',FollowupStatusDeleteController);

    FollowupStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'FollowupStatus'];

    function FollowupStatusDeleteController($uibModalInstance, entity, FollowupStatus) {
        var vm = this;
        vm.followupStatus = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            FollowupStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
